import { ErrorMessage, Formik } from "formik";
import React, { useRef } from "react";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, fileUpload } from "../../../../config";
import Spin from "../../../common/Spin";
import { InviteAccountingFirmSchema } from "../../../common/Validation";
import { MultiSelect } from "primereact/multiselect";
import { useProjectListBasedOnBuilder } from "./ProjectsHelper";
import { formatName } from "../../../common/Misc";

const InviteAccountingFirmModal = ({
  showInviteAccountingFirm,
  handleInviteAccountingFirm,
}) => {
  const builderId = localStorage.getItem("builderId");
  const builderUserId = localStorage.getItem("builderUserId")
    ? localStorage.getItem("builderUserId")
    : "";

  const [loading, setLoading] = useState(false);
  const [defaultData, setDefaultData] = useState({});
  const [selectedProjects, setSelectedProjects] = useState([]);
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.builder_id = builderId ? builderId : "";

    formData.append("email", value?.email ? value?.email : "");

    formData.append("builder_id", value?.builder_id ? value?.builder_id : "");

    if (selectedProjects) {
      if (selectedProjects.length > 0) {
        for (let i = 0; i < selectedProjects.length; i++) {
          formData.append(`builder_project_ids[${i}]`, selectedProjects[i]);
        }
      }
    }

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.INVITE_ACCOUNTING_FIRM}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        handleInviteAccountingFirm();
      }
      return data?.data;
    } catch (error) {
      setDefaultData(value);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  const handleProjectChange = (e, setFieldValue) => {
    setFieldValue("builder_project_ids", e.value);
    setSelectedProjects(e.value);
  };

  const filterProjectInputRef = useRef();

  const handleProjectApplyFilter = () => {
    filterProjectInputRef.current.hide();
  };

  const ProjectResetFunction = () => {
    setSelectedProjects([]);
    filterProjectInputRef && filterProjectInputRef.current.focus();
    filterProjectInputRef.current.hide();
  };

  //Project List
  const { projectLoading, projectList = [] } = useProjectListBasedOnBuilder(
    builderId,
    builderUserId
  );
  const projectListing = projectList?.map((item) => {
    const name =
      item?.project_name +
      (item?.assigned_to
        ? ` (Assign to ${
            item?.accounting_firm?.business_name
              ? item?.accounting_firm?.business_name
              : formatName(
                  item?.assigned_to?.first_name,
                  item?.assigned_to?.last_name
                )
          })`
        : "");
    const id = item?.id;
    const items = { name, id, ...item };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });

  return (
    <>
      <Modal
        size="lg"
        show={showInviteAccountingFirm}
        onHide={handleInviteAccountingFirm}
        dialogClassName="modal-50w small-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        // className="project-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Invite Accounting Firm
        </Modal.Header>
        <Modal.Body>
          {(loading || projectLoading) && <Spin />}
          <Formik
            initialValues={{
              email: defaultData?.email,
            }}
            enableReinitialize
            validationSchema={InviteAccountingFirmSchema}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={handleFormSubmit}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                noValidate
                className="entry-section"
              >
                <div className="form-box">
                  <div className="form-group full-width">
                    <label style={{ marginRight: "100%" }}>
                      <span className="required">*</span>Email
                    </label>
                    <input
                      type="text"
                      name="email"
                      placeholder="Email"
                      value={values?.email ? values?.email : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                    />
                    <span
                      className="text-danger"
                      style={{ color: "red", fontSize: "20px" }}
                    >
                      <ErrorMessage name="email" />
                    </span>
                  </div>
                  <div
                    className="form-group full-width"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    <label>
                      <span className="required">*</span>Projects
                    </label>
                    <MultiSelect
                      value={selectedProjects}
                      selectedItemsLabel={`${selectedProjects?.length} Project(s) Selected`}
                      name="builder_project_ids"
                      onChange={(e) => {
                        handleProjectChange(e, setFieldValue);
                      }}
                      options={projectListing}
                      optionLabel="label"
                      // filter
                      placeholder="Select Projects"
                      maxSelectedLabels={0}
                      ref={filterProjectInputRef}
                      itemTemplate={(item) => (
                        <span className={item?.assigned_to ? "grey-out" : ""}>
                          {item?.label}
                        </span>
                      )}
                      panelFooterTemplate={
                        <>
                          <hr />
                          <Button
                            className="multiSelect-button"
                            onClick={() => {
                              handleProjectApplyFilter();
                            }}
                          >
                            OK
                          </Button>
                          <Button
                            className="multiSelect-button"
                            onClick={() => {
                              ProjectResetFunction();
                            }}
                          >
                            Reset
                          </Button>
                        </>
                      }
                    />
                    <span
                      className="text-danger"
                      style={{ color: "red", fontSize: "20px" }}
                    >
                      <ErrorMessage name="builder_project_ids" />
                    </span>
                  </div>
                </div>

                <div className="modal-footer">
                  <Button type="submit">Invite</Button>
                  <Button
                    className="reset"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      handleInviteAccountingFirm();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InviteAccountingFirmModal;
